import styled from 'styled-components';

import { theme } from '@notino/react-styleguide-v20';

import { ImageWrapper } from '@sharedComponents/Images';

export const Wrapper = styled.div`
  display: flex;
  margin: 1.25rem 0;
  align-items: center;
`;

export const StyledImage = styled(ImageWrapper)`
  height: 3rem;
  width: 3rem;
  margin-right: 1rem;
  border: double 0.25rem transparent;
  border-radius: 50%;
  box-shadow: 0 0 0.625rem ${theme.color.background.tertiary};
`;
